<div class="modal fade" id={{modelId}} tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-scrollable" id="modal">
        <div class="modal-content">
            <div class="modal-body">
                <div class="row modal-heading-row">
                    <div class="row heading-row-right">
                        <img src="../../../../../assets/icons/logo.png" width="35px" height="32px"
                            class="d-inline-block align-top" alt="" loading="lazy" data-dismiss="modal">
                        <div class="modal-Heading">
                            {{modalName}}
                        </div>
                    </div>
                    <img src="../../../../../assets/icons/closeBlack.png" width="18px" height="18px"
                        style="cursor: pointer;" class="d-inline-block align-top" alt="" loading="lazy"
                        data-dismiss="modal" (click)="onCancelClick()">
                </div>
                <hr>
                <div>
                    <div class="modal-form">
                        <form [formGroup]="snoozeReservationForm" #data>
                            <div class="">
                                <div class="columnRowContainer mb-2">
                                    <input type="radio" class="itemCheck marginRight" name="snooze"
                                        formControlName="snooze" id="unsnooze" value="0" (change)="onClick('unsnooze')">
                                    <h5 class="headingText">Unsnooze</h5>
                                </div>
                                <h5 class="descText">When unsnoozed, customers will be able to make bookings online.
                                </h5>
                            </div>
                            <div class="">
                                <div class="columnRowContainer mb-2">
                                    <input type="radio" class="marginRight itemCheck" name="snooze"
                                        formControlName="snooze" id="snooze" (change)="onClick('snooze')" value=1>
                                    <h5 class="headingText">Snooze</h5>
                                </div>
                                <h5 class="descText">When snoozed, customers will NOT be able to make bookings
                                    online.
                                </h5>
                            </div>
                            <div class="mt-3" *ngIf="snoozeReservationForm.controls['snooze'].value == 1">
                                <select class="custom-select" style=" font-size: 14px;" id="inlineFormCustomSelect3"
                                    formControlName="reservation_available_in" (ngModelChange)="selectTimezone($event)"
                                    [ngClass]="{ 'is-invalid': submitted && sf['reservation_available_in'].errors?.required }">
                                    <option value='' selected>Choose a time...</option>
                                    <option *ngFor="let time of availableTimes let i = index" [ngValue]="time.value">
                                        {{time.timeZone}}
                                    </option>
                                </select>
                                <div class="text-danger">
                                    <div *ngIf="submitted && sf['reservation_available_in'].errors?.required">
                                        Snooze time is required!
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="(type == 'custom_hours' || type == 'custom_days') && snoozeReservationForm.controls['snooze'].value == 1 "
                                class="mt-3">
                                <input class="form-control" type="number" placeholder="" value="1"
                                    formControlName="custom_value" placeholder="Hours/Days">
                            </div>

                        </form>
                    </div>
                    <div class="row" *ngIf="submitted">
                        <div class="col-12 pt-2">
                            <div *ngIf="submitted && !loading">
                                <p *ngIf="submitted && formMessage != ''" class="alert alert-success">
                                    {{formMessage}}</p>
                                <p *ngIf="!submitted && formMessage != ''" class="alert alert-danger">
                                    {{formMessage}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 modal-button-div mt-3">
                        <button class="btn modal-btn-button" type="button" (click)="onSaveClick()">
                            <span *ngIf="!loading">Save Changes</span>
                            <div *ngIf="loading" style="position: absolute;">
                                <ngx-spinner bdColor="rgba(255,255,255,0)" size="small" color="#ffffff"
                                    type="ball-clip-rotate" [fullScreen]="false"></ngx-spinner>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>